import type { DialogProps } from '@radix-ui/react-dialog';

import { Drawer } from './Drawer';

type FilterDrawerProps = DialogProps;

export function FilterDrawer({
  open,
  onOpenChange,
  children,
}: FilterDrawerProps) {
  return (
    <Drawer.Root open={open} onOpenChange={onOpenChange}>
      <Drawer.Content data-testid="filters-drawer">{children}</Drawer.Content>
    </Drawer.Root>
  );
}

FilterDrawer.displayName = 'FilterDrawer';
